import * as React from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { CoverImage } from './CoverImage';
import { Overlap } from './Overlap';
import { SectionInfoNarrow } from './SectionInfoNarrow';

export const SectionServiceItemStyle = styled.div`
  color: white;

  h1 {
    padding-top: 100px;
  }
`;

const SectionServiceItem: React.FC = () => {
  const params = useParams<{ urltag: string }>();
  
  return (
    <SectionServiceItemStyle>
      <CoverImage
        url={
          'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        }
      />
      <Overlap yPos={-70}>
        <SectionInfoNarrow
          title={'100% fornøyd garanti!'}
          ingress={
            'Kundene er de viktigste ressursene vi har, derfor ønsker vi alltid det beste for deg'
          }
          info={'Her kommer det etterhvert litt informasjon'}
        />
      </Overlap>
    </SectionServiceItemStyle>
  );
};

export default SectionServiceItem;
